import { comma } from '@/utils/format.util';
import { FlexWrap } from '@repo/components';
import { format } from 'date-fns';
import styled from 'styled-components';
import { ICON_IMAGE_EMPTY } from '@repo/assets';
import { ICON_MAXIMIZE } from '@repo/assets';
import { IGlobalState } from '@/store';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IMG_LOGO_KTP_BLACK, IMG_LOGO_SUCCESSMODE_BLACK } from '@repo/assets';
import { ReactBarcode } from 'react-jsbarcode';

type Props = {
  franchiseeName: string;
  refundIndex: number;
  category: string;
  saleDate: string;
  price: number;
  refund: number;
  purchaseSn: string;
  onOpenPreview: () => void;
};

function ReceiptItem({
  franchiseeName,
  saleDate,
  price,
  refund,
  purchaseSn,
  onOpenPreview,
}: Props) {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;

  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    purchaseDate: ['Date of Purchase', '구매일자'],
    payment: ['Payment', '결제금액'],
    refundAmount: ['Amount of Refund', '환급액'],
  };

  const priceInfo = [
    [
      text.purchaseDate[nationIndex],
      `${format(new Date(saleDate), 'yyyy.MM.dd')}`,
    ],
    [text.payment[nationIndex], `₩ ` + comma(price)],
    [text.refundAmount[nationIndex], `₩ ` + comma(refund)],
  ];

  return (
    <>
      <Container dir='column'>
        <Title>{franchiseeName}</Title>
        <ContentContainer>
          <PriceItem dir='column' justifyContent='center'>
            {priceInfo.map(([key, value]) => (
              <PriceItemText key={key} dir='column'>
                <PriceLabel>{key}</PriceLabel>
                <PriceValue>{value}</PriceValue>
              </PriceItemText>
            ))}
          </PriceItem>
          {purchaseSn && (
            <ImageSection>
              <ImageSizeButton onClick={onOpenPreview}>
                <img src={ICON_MAXIMIZE} alt='' width={30} />
              </ImageSizeButton>
              <ProductImage onClick={onOpenPreview}>
                <FlexWrap alignItems='center' gap='20px'>
                  <CompanyLogo src={IMG_LOGO_SUCCESSMODE_BLACK} />
                  <ServiceLogo src={IMG_LOGO_KTP_BLACK} />
                </FlexWrap>
                <BarcodeImage
                  value={purchaseSn}
                  options={{ format: 'CODE39', displayValue: false }}
                />
                <p>
                  2022
                  <br />
                  <br />
                  KTP 환급전표
                  <br />
                  Korea Taxfree Payment slip fot Tax Refund
                </p>
              </ProductImage>
            </ImageSection>
          )}
          {!purchaseSn && (
            <NoImageContainer
              dir='column'
              justifyContent='center'
              alignItems='center'
            >
              <NoImage src={ICON_IMAGE_EMPTY} />
              <NoImageText>No image</NoImageText>
            </NoImageContainer>
          )}
        </ContentContainer>
      </Container>
    </>
  );
}

const Container = styled(FlexWrap)`
  padding: 30px 0;
  border-bottom: 1px solid #cbccce;
  width: 100%;
  :last-child {
    margin-bottom: 24px;
  }
`;

const ContentContainer = styled(FlexWrap)``;
const PriceItem = styled(FlexWrap)`
  gap: 8px;
  flex: 1;
`;
const PriceItemText = styled(FlexWrap)``;
const Title = styled.h3`
  color: #030303;
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  margin-bottom: 8px;
`;
const PriceLabel = styled.span`
  color: #80848a;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;
const PriceValue = styled.span`
  color: #030303;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
`;
const NoImageContainer = styled(FlexWrap)`
  background-color: #ececec;
  border: 1px solid #9fa1a7;
  border-radius: 4px;
  width: 152px;
  height: 126px;
`;
const NoImage = styled.img`
  width: 56px;
  height: 56px;
  margin-bottom: 8px;
`;
const NoImageText = styled.span`
  font-size: 11px;
  color: #9fa1a7;
  text-align: center;
  line-height: 20px;
`;
const ProductImage = styled.button`
  width: 160px;
  height: 140px;
  border-radius: 4px;
  cursor: pointer;
  :hover {
    opacity: 70%;
  }
  transition: all 300ms ease-in;

  p {
    color: #5f6165;
    text-align: center;
    font-size: 8px;
    line-height: 10px;
  }
`;

const BarcodeImage = styled(ReactBarcode)`
  width: 120px;
  height: 40px;
`;

const CompanyLogo = styled.img`
  width: 66px;
`;
const ServiceLogo = styled.img`
  width: 60px;
`;

const ImageSection = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: flex-start;
  gap: 16px;
`;

const ImageSizeButton = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
`;

export default ReceiptItem;
